import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=4dd4de2c&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=4dd4de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4de2c",
  null
  
)

export default component.exports